import { observer } from 'mobx-react-lite'
import { NumericInputContainer } from '@/components/inputs/NumericInputContainer'
import { ManageUserCapacityDialog } from '@/features/user-management/ManageUserCapacityDialog'
import { type ManageUserCapacityDialogViewModel } from './ManageUserCapacityDialogViewModel'

export interface ManageUserCapacityDialogContainerProps {
  vm: ManageUserCapacityDialogViewModel
}

export const ManageUserCapacityDialogContainer = observer(
  function ManageUserCapacityDialogContainer({
    vm,
  }: ManageUserCapacityDialogContainerProps) {
    return (
      <ManageUserCapacityDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        capacityType={vm.capacityType}
        onCapacityTypeChange={vm.setCapacityType}
        canChooseCapacityType={vm.canChooseCapacityType}
        selectedUserName={vm.selectedUserName}
        selectedUserCount={vm.selectedUserIds.length}
        workspaceName={vm.workspace.name}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      >
        {vm.capacityType === 'Workspace' && (
          <NumericInputContainer
            label="Workspace Amount"
            placeholder="0"
            help={`User max concurrent jobs`}
            model={vm}
            field="workspaceCapacity"
            testId="user-capacity-workspace-amount"
            precision={0}
          />
        )}

        {vm.capacityType === 'Global' && (
          <NumericInputContainer
            label="Global Amount"
            placeholder="0"
            help={`User max concurrent jobs`}
            model={vm}
            field="globalCapacity"
            testId="user-capacity-global-amount"
            precision={0}
          />
        )}
      </ManageUserCapacityDialog>
    )
  },
)
